export enum OAuthLoginError {
  UserNotBelgian = 'user_not_belgian',
  UserNotFound = 'user_not_found',
  UserBlocked = 'user_blocked',
  AuthorizationSessionExpired = 'authorization_session_expired',
  NoCredentialsProvided = 'no_credentials_provided',
}
